if (!customElements.get('product-shipping-offer')) {
  class ProductShippingOffer extends HTMLElement {
    connectedCallback() {
      this.quantityInput = document.getElementById(this.dataset.quantityInput);
      this.message = this.querySelector('.two-jar-shipping-offer__text');
      this.choices = [...this.querySelectorAll('[data-quantity]')];
      this.threshold = Number(this.dataset.threshold || 2);

      if (!this.quantityInput || !this.message) return;

      this.update = this.update.bind(this);
      this.selectQuantity = this.selectQuantity.bind(this);
      this.quantityInput.addEventListener('input', this.update);
      this.quantityInput.addEventListener('change', this.update);
      this.addEventListener('click', this.selectQuantity);
      this.update();
    }

    disconnectedCallback() {
      this.quantityInput?.removeEventListener('input', this.update);
      this.quantityInput?.removeEventListener('change', this.update);
      this.removeEventListener('click', this.selectQuantity);
    }

    selectQuantity(event) {
      const choice = event.target.closest('[data-quantity]');
      if (!choice || !this.contains(choice)) return;

      this.quantityInput.value = choice.dataset.quantity;
      this.quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    update() {
      const quantity = Number(this.quantityInput.value || 1);
      const unlocked = quantity >= this.threshold;

      this.toggleAttribute('data-unlocked', unlocked);
      this.choices.forEach((choice) => {
        choice.setAttribute('aria-pressed', String(Number(choice.dataset.quantity) === quantity));
      });
      this.message.textContent = unlocked
        ? this.message.dataset.unlockedMessage
        : this.message.dataset.pendingMessage;
    }
  }

  customElements.define('product-shipping-offer', ProductShippingOffer);
}
